import Api from '../../../helpers/Api';

export const REQUEST_NOW_PLAYING = 'REQUEST_NOW_PLAYING';
const request = () => ({
    type: REQUEST_NOW_PLAYING,
});

export const UPDATE_NOW_PLAYING = 'UPDATE_NOW_PLAYING';
const update = (music) => ({
    type: UPDATE_NOW_PLAYING,
    music,
    receivedAt: Date.now(),
});

export const END_REQUEST_NOW_PLAYING = 'END_REQUEST_NOW_PLAYING';
const end = () => ({
    type: END_REQUEST_NOW_PLAYING,
});

// eslint-disable-next-line padding-line-between-statements
const getMetadata = (url) => (dispatch, getState) => {
    dispatch(request());

    return Api.get(url)
        .then((json) => {
            if (json.status === 'success') {
                const currentArtist = getState().aovivoBar.NowPlaying.musicLive.artist;
                const currentMetaId = getState().aovivoBar.MediaPlayer.currentStream.metaId;
                const isCurrentMetaId = url.includes(currentMetaId);

                // Only update if there's any change and if the executed request was for the current metaId (when changing the streams this might cause confusion on slow network connections)
                if (json.data && json.data.artist !== currentArtist && isCurrentMetaId) {
                    dispatch(update(json.data));
                }

                return dispatch(end());
            }

            throw `error from server: ${json.message}`;
        })
        .catch((err) => {
            dispatch(end());

            // eslint-disable-next-line no-console
            console.log('got error when fetching meta:', err);
        });
};

// eslint-disable-next-line padded-blocks
export const fetchNowPlayingIfNeeded = () => (dispatch, getState) => {

    const isFetching = getState().aovivoBar.NowPlaying.isFetching;
    const currentMetaId = getState().aovivoBar.MediaPlayer.currentStream.metaId;
    const FYC = Math.floor(Date.now() / 1000 / 60 / 5); // create a new timestamp every 5 minutes
    // We use the FYC to invalidate the url in case it got corrupted. This happens if there are problems with sucuri, or the server on one single request
    // As mobile browsers have some aggrassive caching, this can lead to never more updating meta data
    const url = `/api/v1/aovivo/getCurrentSongInfo/${currentMetaId}?FYC=${FYC}`;

    // Get data only if not already fetching
    return !isFetching ? dispatch(getMetadata(url)) : Promise.resolve();
};
